module.exports = __webpack_public_path__ + "static/media/zocalo10.dadc5455.jpg";